<script>
import Vue from "vue";
import AromaAlphabetCheckoutForm from "./AromaAlphabetCheckoutForm.vue";
import AromaAlphabetLeft from "./AromaAlphabetLeft.vue";
import Footer from "../../Footer.vue";

export default {
  name: "AromaAlphabetCheckout",
  page: {
    title: "Checkout",
    meta: [{ name: "description", content: "The Checkout page." }],
  },
  props: ["combos", "variant"],
  components: {
    AromaAlphabetLeft,
    AromaAlphabetCheckoutForm,
    Footer,
  },
  data: function () {
    return {
      changeBus: new Vue(),
      guaranteeImg: "redlock-ssl-30days.jpg",
    };
  },
};

</script>

<template>
  <b-container style="background-color: white; padding: 0 3rem 0 3rem;">
    <b-row>
      <b-col>
        <div style="text-align: center; margin-bottom: 2rem; padding: 3rem 3rem 0rem 3rem">
          <p style="color: #e00b11; font-weight: 700; font-size: 52px;">Create Blends That Work</p>
          <p style="font-weight: 700; letter-spacing: 0.15rem; color: #293847; font-size: 38px;">for Your Family and Clients.</p>
          <p style="padding: 1rem 3rem 0rem 3rem; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 24px;">
            Understand why recipes work or don't work, have lifetime access, get a certificate of completion, and exclusive bonuses.
            Save your spot NOW with the <b>early bird price</b>.
            You can split your payment in 10x.
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left; color: #293847">
        <AromaAlphabetLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <AromaAlphabetCheckoutForm
          :loadCombos="combos"
          :variant="variant"
          :guaranteeImg="guaranteeImg"
          :changeBus="changeBus"
          :discount="'75%'"
          class="h-100"
        />
      </b-col>
    </b-row>
    <b-row style="padding-top: 2em;">
      <b-col sm="12" lg="12">
        <b-card no-body>
          <b-row>
            <b-col md="4">
              <b-card class="text-center" border-variant="light" style="padding-top: 1.75rem">
                <b-card-img
                  img-top
                  :src="require('@/assets/powerdrops/thumb-melani.png')"
                  style="height: 90px; width: 90px; display: block; margin: auto"
                />
                <b-card-title title="Melani Kovač"></b-card-title>
                <b-card-body class="text-center"
                  >Dropsmart's founder, Aromatherapist and Lecturer at Higher school of applied sciences</b-card-body
                >
              </b-card>
            </b-col>
            <b-col md="8">
              <b-card-body style="line-height: 1.5em; font-size: 1.2em; padding: 2rem">
                <h5 style="font-weight: bold">Your teacher</h5>
                <p>
                  Melani Kovač devoted her last 15+ years solely to promoting aromatherapy. To serve this purpose she’s founded
                  Aromainstitut through which she organises and supports different aromatherapy projects, collaborates with colleagues,
                  non-profit organisations, homes for the elderly, hospitals, universities and anyone who can benefit from aromatherapy or
                  is hoping to incorporate aromatherapy in their work. Her IT background, curiosity as well as working as an educator for a
                  very wide variety of students along with collaborating with distillers, sellers, nurses and scientists inspired her to
                  create a global online platform for all essential oil users and sellers - Dropsmart. Her goal is to make aromatherapy
                  simple, fun and as precise and as safe as possible.
                </p>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <Footer />
  </b-container>
</template>

<style lang="scss">
$vs-state-active-bg: #f7f7f7;
$vs-state-active-color: #444;

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 600;
    color: black;
  }
}
@media screen and (min-width: 481px) {
  /*.header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }*/
}
.checkout-content {
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  align-items: stretch;
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}

#bonus-left {
  font-size: 1.05rem;
  line-height: 2.75em;
}

ul#bonus-left > li {
  font-weight: bold;
  list-style: disc;
}
ul#bonus-left > li li {
  font-weight: normal;
  list-style: disc;
}

ul#bonus-right {
  line-height: 2.75em;
  width: 88%;
}

ul#bonus-right > li {
  font-weight: bold;
  list-style: disc;
}

ul#bonus-right > li li {
  font-weight: normal;
  line-height: 1em;
  margin-bottom: 2rem;
  list-style: disc;
}

ul#bonus-right h4 {
  font-size: 1.1rem;
  margin-bottom: 6px;
  margin-top: 16px;
}

#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}
</style>
